import type { PropsWithChildren, ReactNode } from 'react';

import { Radio } from '@coop/components';

import { useCurrentPriceType } from '../../../common/hooks/useCurrentPriceType';
import { PriceType } from '../../../common/models/priceData/priceData';
import { ga4B2BTracking } from '../../../common/tracking/ga4/b2b';
import styles from './PriceTypeSwitch.module.scss';

const PriceTypeSwitch = (props: { label?: ReactNode; ariaLabel?: string }) => {
    const { currentPriceType, setPricesWithTax, setPricesWithoutTax } = useCurrentPriceType();

    const onToggle = (newValue: string) => {
        if (newValue === PriceType.IncludeTax) {
            setPricesWithTax();
            ga4B2BTracking.vatSelectionClick(PriceType.IncludeTax);
            return;
        }

        if (newValue === PriceType.ExcludeTax) {
            setPricesWithoutTax();
            ga4B2BTracking.vatSelectionClick(PriceType.ExcludeTax);
        }
    };

    return (
        <Radio.Group
            className="u-flex"
            onChange={onToggle}
            value={currentPriceType}
            label={props.label}
            aria-label={props.ariaLabel}
            orientation="horizontal"
        >
            <Radio.Item
                value={PriceType.ExcludeTax}
                label="exkl. moms"
                aria-label="exklusive moms"
            />

            <Radio.Item
                value={PriceType.IncludeTax}
                label="inkl. moms"
                aria-label="inklusive moms"
            />
        </Radio.Group>
    );
};

export const PriceTypeSwitchStyledContainer = (props: PropsWithChildren) => (
    <div className={styles.PriceTypeSwitch}>{props.children}</div>
);

export default PriceTypeSwitch;
